// extracted by mini-css-extract-plugin
export default {"card":"SY-z","carouselContainer":"TY-z","carouselContent":"UY-z"};